import { createReducer, ActionType, createAsyncAction } from "typesafe-actions";
import {
  AccessRolesListDto,
  GetAccessRoleListQuery,
  AccessRoleDetailDto,
  AccessRightsUpdateRequest,
} from "Api/Api";

export type AccessRolesState = {
  accessRoles: AccessRolesListDto;
  accessRoleDetail: AccessRoleDetailDto | null;
  isLoading: boolean;
};

export const getAccessRolesAsync = createAsyncAction(
  "@accessRoles/GET_ACCESS_ROLES_REQUEST",
  "@accessRoles/GET_ACCESS_ROLES_SUCCESS",
  "@accessRoles/GET_ACCESS_ROLES_FAILURE",
)<GetAccessRoleListQuery, AccessRolesListDto, Error>();

export const getAccessRoleDetailAsync = createAsyncAction(
  "@accessRoles/GET_ACCESS_ROLE_DETAIL_REQUEST",
  "@accessRoles/GET_ACCESS_ROLE_DETAIL_SUCCESS",
  "@accessRoles/GET_ACCESS_ROLE_DETAIL_FAILURE",
)<number, AccessRoleDetailDto, Error>();

export const updateRoleAccessRightsAsync = createAsyncAction(
  "@accessRoles/UPDATE_ROLE_ACCESS_RIGHTS_REQUEST",
  "@accessRoles/UPDATE_ROLE_ACCESS_RIGHTS_SUCCESS",
  "@accessRoles/UPDATE_ROLE_ACCESS_RIGHTS_FAILURE",
)<AccessRightsUpdateRequest, void, Error>();

export type AccessRoleAction =
  | ActionType<typeof getAccessRolesAsync>
  | ActionType<typeof getAccessRoleDetailAsync>
  | ActionType<typeof updateRoleAccessRightsAsync>;

export const accessRolesReducer = createReducer<
  AccessRolesState,
  AccessRoleAction
>({
  accessRoles: {
    count: 0,
    accessRoles: [],
  },
  accessRoleDetail: null,
  isLoading: false,
})
  .handleAction(getAccessRolesAsync.request, state => {
    return { ...state, isLoading: true };
  })
  .handleAction(getAccessRolesAsync.success, (state, action) => {
    return {
      ...state,
      accessRoles: action.payload,
      isLoading: false,
    };
  })
  .handleAction(getAccessRolesAsync.failure, state => {
    return {
      ...state,
      isLoading: false,
    };
  })

  .handleAction(getAccessRoleDetailAsync.request, state => {
    return { ...state, isLoading: true };
  })
  .handleAction(getAccessRoleDetailAsync.success, (state, action) => {
    return {
      ...state,
      accessRoleDetail: action.payload,
      isLoading: false,
    };
  })
  .handleAction(getAccessRoleDetailAsync.failure, state => {
    return {
      ...state,
      isLoading: false,
    };
  });
